import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "../stores/user";
import storage from "../utils/storage";

const routes = [
  {
    path: "/",
    component: () => import("@/layouts/DefaultLayout.vue"),
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "Home",
        component: () => import("@/views/Home.vue"),
        meta: {
          title: "首页",
          requiresAuth: true,
        },
      },
      {
        path: "record",
        name: "Record",
        component: () => import("@/views/Record.vue"),
        meta: {
          title: "最近浏览",
          requiresAuth: true,
        },
      },
      {
        path: "answer",
        name: "Answer",
        component: () => import("@/views/Answer.vue"),
        meta: {
          title: "写回答",
          requiresAuth: true,
        },
      },
      {
        path: "answerDetail/:id",
        name: "AnswerDetail",
        component: () => import("@/views/AnswerDetail.vue"),
        meta: {
          title: "回答详情",
          requiresAuth: true,
        },
      },
      {
        path: "article",
        name: "Article",
        component: () => import("@/views/Article.vue"),
        meta: {
          title: "写文章",
          requiresAuth: true,
        },
      },
      {
        path: "articleDetail/:id",
        name: "ArticleDetail",
        component: () => import("@/views/ArticleDetail.vue"),
        meta: {
          title: "文章详情",
          requiresAuth: true,
        },
      },
      {
        path: "profile",
        name: "profile",
        component: () => import("@/views/Profile.vue"),
        meta: {
          title: "个人中心",
          requiresAuth: true,
        },
      },
      {
        path: "columnDetail/:id",
        name: "ColumnDetail",
        component: () => import("@/views/ColumnDetail.vue"),
        meta: {
          title: "专栏详情",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: { title: "登录" },
  },
  {
    path: "/sso-login",
    name: "SsoLogin",
    component: () => import("@/views/SsoLogin.vue"),
    meta: { title: "SSO登录" },
  },
  {
    path: "/accountDetail/:id",
    component: () => import("@/views/Datail.vue"),
    meta: { title: "账号详情" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const whiteList = ["/login", "/sso-login"];
  const user = useUserStore();
  if (user.token) {
    if (to.path.includes("/login")) {
      // 如果在登录页且 Token 未过期，重定向到首页
      if (!storage.isExpired("token")) {
        next("/");
        return;
      } else {
        next();
      }
    }
  } else {
    user.clear();
    if (!whiteList.includes(to.path)) {
      next("/login");
      return;
    }
  }
  next();
});

export default router;
